type estudios = 'Secundaria' | 'Terciario' | 'Universitario' | 'Posgrado' | 'Otro';
type formSumate = {
  nombre: string;
  telefono: string;
  email: string;
  edad: string;
  barrio: string;
  estudios: estudios | null;
  profesion: string;
  experienciaEnVentas: boolean | null;
  actividad: string;
  dedicacionFull: boolean | null;
  descripcion: string;
  linkedin: string;
  cv: File | null;
};

const formSumateInit: formSumate = {
  nombre: '',
  telefono: '',
  email: '',
  edad: '',
  barrio: '',
  estudios: null,
  profesion: '',
  experienciaEnVentas: null,
  actividad: '',
  dedicacionFull: null,
  descripcion: '',
  linkedin: '',
  cv: null
};

export type { formSumate, estudios };
export { formSumateInit };
